const state = {
  sede_data: [],
};

export default state;
